var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"-title"},[_vm._v("\n  "+_vm._s(_vm.title[0])+"\n  "),(_vm.title.length > 1)?_c('span',{staticClass:"sub"},[_vm._v(_vm._s(_vm.title[1]))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2424ea75","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/di-ding/common/title-bar.vue
// module id = null
// module chunks = 